import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon, CheckIcon, ClockIcon, MailIcon, MapPinIcon, SunIcon, WalletIcon } from 'lucide-react';
import { NotFound } from './NotFound';
import { vacancies } from '../data/vacancies';
import { clinic } from '../data/clinic';
export function VacancyDetail() {
  const {
    slug
  } = useParams();
  const vacancy = vacancies.find(v => v.slug === slug);
  if (!vacancy) return <NotFound data-id="element-912" data-mp="1jy5fxrixprm6" />;
  const facts = [{
    icon: ClockIcon,
    label: 'Uren',
    value: vacancy.hours
  }, {
    icon: SunIcon,
    label: 'Werkschema',
    value: vacancy.schedule
  }, {
    icon: WalletIcon,
    label: 'Salaris',
    value: vacancy.salary
  }, {
    icon: MapPinIcon,
    label: 'Locatie',
    value: `${clinic.street}, ${clinic.city}`
  }];
  const mailto = `mailto:${vacancy.apply.email}?subject=${encodeURIComponent(`Sollicitatie ${vacancy.title}`)}`;
  const others = vacancies.filter(v => v.slug !== vacancy.slug);
  return <>
      <section className="border-b border-line bg-surface" data-id="element-913" data-mp="2zgqfnsz1rsj0">
        <div className="mx-auto max-w-7xl px-5 pb-12 pt-10 lg:px-8 lg:pb-14" data-id="element-914" data-mp="367ucdqzxrzr6">
          <Link to="/vacatures" className="inline-flex items-center gap-2 text-sm font-medium text-muted hover:text-primary" data-id="element-915" data-mp="3a9fuprv8p68r">
            <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-916" data-mp="3f9tukmmot9vp" />
            Alle vacatures
          </Link>
          <h1 className="mt-6 max-w-3xl font-display text-4xl font-semibold tracking-tight text-ink sm:text-5xl" data-id="element-917" data-mp="3k7lvg65b86c1">{vacancy.title}</h1>
          <p className="mt-4 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-918" data-mp="2rjpswkt27k7c">{vacancy.lead}</p>
          <dl className="mt-10 grid gap-px overflow-hidden rounded-2xl bg-line ring-1 ring-line sm:grid-cols-2 lg:grid-cols-4" data-id="element-919" data-mp="2wiswe0te5id7">
            {facts.map(({
            icon: Icon,
            label,
            value
          }) => <div key={label} className="flex gap-3 bg-white p-5" data-id="element-920" data-mp="31bcbj27q8lk4">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden="true" data-id="element-921" data-mp="23tlxv1txssry" />
                <div data-id="element-922" data-mp="28rx7bbgbl19n">
                  <dt className="text-xs font-medium text-muted" data-id="element-923" data-mp="28r5c41qmx5jw">{label}</dt>
                  <dd className="mt-0.5 text-[15px] font-medium text-ink" data-id="element-924" data-mp="20r7nx43tsdet">{value}</dd>
                </div>
              </div>)}
          </dl>
        </div>
      </section>

      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-14 lg:grid-cols-[minmax(0,1fr)_340px] lg:gap-20 lg:px-8 lg:py-20" data-id="element-925" data-mp="2ahafr0z7nlbk">
        <article className="max-w-3xl space-y-12" data-id="element-926" data-mp="25k0ulxiutvtj">
          {vacancy.sections.map(s => <section key={s.title} data-id="element-927" data-mp="1hu6glcmsu17p">
              <h2 className="font-display text-2xl font-semibold text-ink" data-id="element-928" data-mp="1ds2w5yi5jmaa">{s.title}</h2>
              {s.paragraphs?.map(p => <p key={p} className="mt-4 text-[17px] leading-relaxed text-muted" data-id="element-929" data-mp="1rsvr2kcd8jdx">
                  {p}
                </p>)}
              {s.items && <ul className="mt-5 space-y-3" data-id="element-930" data-mp="336r5fqvg4o43">
                  {s.items.map(item => <li key={item} className="flex gap-3 text-[16px] leading-relaxed text-ink" data-id="element-931" data-mp="2y7wm8ntkgxjg">
                      <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-primary" aria-hidden="true" data-id="element-932" data-mp="k0597bz3oej0" />
                      {item}
                    </li>)}
                </ul>}
            </section>)}
        </article>

        <aside className="space-y-6 lg:sticky lg:top-32 lg:self-start" data-id="element-933" data-mp="b11pq6w0tx3z">
          <div className="rounded-3xl bg-ink p-7 text-white" data-id="element-934" data-mp="fzlbo7am78wc">
            <h2 className="font-display text-xl font-semibold" data-id="element-935" data-mp="13o4j6klubhnd">Solliciteren</h2>
            <p className="mt-3 text-[15px] leading-relaxed text-white/75" data-id="element-936" data-mp="13q8w1s1pvqzs">{vacancy.apply.text}</p>
            <a href={mailto} className="mt-6 flex items-center justify-center gap-2 rounded-full bg-white py-3 text-[15px] font-semibold text-ink transition-colors duration-150 hover:bg-primary-soft" data-id="element-937" data-mp="17ru4n177xj46">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-938" data-mp="1mmgy6mzfnlqv" />
              Stuur je cv en motivatie
            </a>
            <dl className="mt-6 space-y-3 border-t border-white/15 pt-5 text-sm" data-id="element-939" data-mp="1res364915xqa">
              <div data-id="element-940" data-mp="2s5yxi408e2v">
                <dt className="text-white/60" data-id="element-941" data-mp="2sp4s0gdrc0j">Contactpersoon</dt>
                <dd className="font-medium" data-id="element-942" data-mp="3txp9uiy6s9bb">{vacancy.apply.contact}</dd>
              </div>
              <div data-id="element-943" data-mp="3pwc223bj9w1r">
                <dt className="text-white/60" data-id="element-944" data-mp="3pvtz6nud8jkv">E-mail</dt>
                <dd className="break-all font-medium text-cyan" data-id="element-945" data-mp="3pygg3e35cbfr">{vacancy.apply.email}</dd>
              </div>
            </dl>
          </div>

          <div className="rounded-3xl border border-line p-7" data-id="element-946" data-mp="linesm3qnf6t">
            <h2 className="font-display text-lg font-semibold text-ink" data-id="element-947" data-mp="hgsd3ghwazsi">Andere vacatures</h2>
            <ul className="mt-3 divide-y divide-line" data-id="element-948" data-mp="hj67ro8ny9zj">
              {others.map(v => <li key={v.slug} data-id="element-949" data-mp="cnzbh1hq47kn">
                  <Link to={`/vacatures/${v.slug}`} className="block py-3 text-[15px] text-ink hover:text-primary" data-id="element-950" data-mp="7rimk52p9p6i">
                    {v.title}
                  </Link>
                </li>)}
            </ul>
          </div>
        </aside>
      </div>
    </>;
}